import React, { useState, useEffect } from "react";
import {
  FaIdCard, FaDownload, FaPrint, FaCalendarAlt, FaSearch, FaCalendar,
  FaClock, FaEye, FaUser, FaMapMarkerAlt, FaEnvelope, FaPhone, FaTint,
  FaBuilding, FaGlobe, FaLink, FaCheckCircle, FaTimes, FaSpinner,
  FaArrowLeft, FaArrowRight, FaFilter, FaSync, FaEdit, FaTrash,
  FaExclamationTriangle, FaEditAlt, FaSave, FaTimesCircle
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import stateCityData from "../../../data/states.json";



const VerifiedIdCard = () => {
  const [verifiedCards, setVerifiedCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Popup modal state
  const [showEditModal, setShowEditModal] = useState(false);
  const [showApproveSpinner, setShowApproveSpinner] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [search, setSearch] = useState("");
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [channelLogoFile, setChannelLogoFile] = useState(null);
  const [channelTypes, setChannelTypes] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  // Pagination and filter states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();

  // Filter and pagination logic
  const getFilteredCards = () => {
    let filtered = verifiedCards.filter(card => {
      const matchesSearch = !search ||
        (card.name && card.name.toLowerCase().includes(search.toLowerCase())) ||
        (card.email && card.email.toLowerCase().includes(search.toLowerCase())) ||
        (card.mobileNo && card.mobileNo.toString().includes(search)) ||
        (card.iinsafId && card.iinsafId.toLowerCase().includes(search.toLowerCase()));

      return matchesSearch;
    });

    // Sort by latest approved date first (most recent first)
    filtered.sort((a, b) => {
      const dateA = new Date(a.updatedAt || a.createdAt || 0);
      const dateB = new Date(b.updatedAt || b.createdAt || 0);
      return dateB - dateA; // Descending order (latest first)
    });

    return filtered;
  };

  const filteredCards = getFilteredCards();
  // Use backend pagination data instead of calculating from filtered cards
  const paginatedCards = filteredCards; // Cards are already paginated from backend

  useEffect(() => {
    fetchVerifiedCards(currentPage);
    fetchAdPricing();
  }, [currentPage]);

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Fetch channel types and platforms from ad pricing API
  const fetchAdPricing = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/get/ad/pricing`
      );
      setChannelTypes(res.data.data.channelType || []);
      setPlatforms(res.data.data.plateforms || []);
    } catch (err) {
      console.error("Error fetching ad pricing:", err);
    }
  };

  const fetchVerifiedCards = async (page = 1) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/get/approved/icards?page=${page}&limit=50`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("approved id cards response:", response);

      const cardsData =
        response.data.reportersIdCard ||
        response.data.data ||
        response.data ||
        [];

      if (Array.isArray(cardsData)) {
        setVerifiedCards(cardsData);

        // Update pagination data if available
        if (response.data.pagination) {
          setTotalPages(response.data.pagination.totalPages);
          setTotalCount(response.data.pagination.totalCount);
        }
      } else {
        console.warn("API response is not an array:", cardsData);
        setVerifiedCards([]);
      }
    } catch (err) {
      console.error("Error fetching verified ID cards:", err);
      setError(
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch verified ID cards"
      );
      setVerifiedCards([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle form submission for editing ID card

  const handleSubmit = async () => {
    setShowApproveSpinner(true);
    try {
      const formData = new FormData();

      // Append all regular text fields
      formData.append("name", selectedCard.name || "");
      formData.append("designation", selectedCard.designation || "");
      formData.append("email", selectedCard.email || "");
      formData.append("mobileNo", selectedCard.mobileNo || "");
      formData.append("aadharNo", selectedCard.aadharNo || "");
      formData.append("bloodGroup", selectedCard.bloodGroup || "");
      formData.append("dateOfBirth", selectedCard.dateOfBirth || "");
      formData.append("channelName", selectedCard.channelName || "");
      formData.append("channelType", selectedCard.channelType || "");
      formData.append("plateform", selectedCard.plateform || "");
      formData.append("ResidentialAddress", selectedCard.ResidentialAddress || ""
      );
      formData.append("city", selectedCard.city || "");
      formData.append("state", selectedCard.state || "");
      formData.append("pincode", selectedCard.pincode || "");

      // Append channelLinks as JSON string
      // formData.append(
      //   "channelLinks",
      //   JSON.stringify(selectedCard.channelLinks || [])
      // );

      // Append reporter image if changed
      if (profileImageFile) {
        formData.append("profileImage", profileImageFile);
      }

      // Append channel logo if changed
      if (channelLogoFile) {
        formData.append("channelLogo", channelLogoFile);
      }

      // API Request
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/update/reporter/id/card/${selectedCard._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      alert("ID card updated successfully!");
      console.log("Updated response:", response);
      setShowEditModal(false); // Close modal
      setProfileImageFile(null);
      setChannelLogoFile(null);
    } catch (error) {
      console.error("Update failed:", error);
      alert(error?.response?.data?.message || "Update failed.");
    } finally {
      setShowApproveSpinner(false);
    }
  }

  // Handle deletion of an ID card
  const handleDeleteCard = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this ID card? This action cannot be undone.");
    if (!isConfirmed) return;

    try {
      setLoading(true);
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/admin/delete/reporter-id-card/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      toast.success("ID card deleted successfully");
      fetchVerifiedCards(currentPage); // Refresh list
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error(error?.response?.data?.message || "Delete failed.");
    } finally {
      setLoading(false);
    }
  };

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 py-6">
        <div className="w-full px-6">
          <div className="flex justify-center items-center h-96">
            <div className="text-center">
              <div className="relative mb-6 w-20 h-20 grid place-items-center mx-auto">
                <span className="absolute inset-0 rounded-full border-4 border-transparent border-r-green-600 animate-spin" style={{ borderWidth: "4px" }} />
                <span className="absolute inset-0 m-2 rounded-full border-4 border-transparent border-r-green-500 animate-spin-slow" style={{ borderWidth: "4px", animationDuration: "2s" }} />
                <span className="absolute inset-0 m-4 rounded-full border-4 border-transparent border-r-green-400 animate-spin-slower" style={{ borderWidth: "4px", animationDuration: "3s" }} />
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">Loading Approved ID Cards</h3>
              <p className="text-gray-500">Please wait while we fetch the data...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-100 p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-center items-center h-96">
            <div className="text-center bg-white p-8 rounded-2xl shadow-lg border border-red-200">
              <FaExclamationTriangle className="text-6xl text-red-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-red-700 mb-2">Error Loading Data</h3>
              <p className="text-red-600 mb-4">{error}</p>
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 py-6">
        <div className="w-full px-6">
          {/* Header Section */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 mb-6 overflow-hidden">
            <div className="bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 px-6 py-8">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center">
                    <FaIdCard className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h1 className="text-3xl font-bold text-white">Approved ID Cards</h1>
                    <p className="text-green-100 mt-1">Manage and view approved ID card applications</p>
                  </div>
                </div>
                <div className="text-right text-white">
                  <div className="text-2xl font-bold">{filteredCards.length}</div>
                  <div className="text-green-100 text-sm">Total Approved</div>
                </div>
              </div>
            </div>

            {/* Search and Filter Section */}
            <div className="p-6 bg-gray-50 border-b border-gray-200">
              <div className="flex flex-col lg:flex-row gap-4">
                <div className="flex-1">
                  <div className="relative">
                    <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                    <input
                      type="text"
                      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white"
                      placeholder="Search by name, email, mobile, or IINSAF ID..."
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={() => window.location.reload()}
                    className="px-4 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors flex items-center gap-2"
                  >
                    <FaSync className="w-4 h-4" />
                    Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
            {paginatedCards.length > 0 ? (
              <>
                {/* Table */}
                <div className="overflow-x-auto">
                  <table className="min-w-full">
                    <thead>
                      <tr className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                        <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center justify-center gap-2">
                            <FaIdCard className="w-4 h-4" />
                            S.No
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center gap-2">
                            <FaUser className="w-4 h-4" />
                            User
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center gap-2">
                            <FaIdCard className="w-4 h-4" />
                            IINSAF ID
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center gap-2">
                            <FaEnvelope className="w-4 h-4" />
                            Contact
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center gap-2">
                            <FaMapMarkerAlt className="w-4 h-4" />
                            Location
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center gap-2">
                            <FaClock className="w-4 h-4" />
                            Updated At
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center gap-2">
                            <FaCalendar className="w-4 h-4" />
                            Date
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center gap-2">
                            <FaCheckCircle className="w-4 h-4" />
                            Status
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          <div className="flex items-center gap-2">
                            <FaGlobe className="w-4 h-4" />
                            Channels
                          </div>
                        </th>
                        <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {paginatedCards.map((card, index) => (
                        <tr key={card._id || card.id || index} className="hover:bg-gray-50 transition-colors">
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <div className="text-sm font-medium text-gray-900">
                              {((currentPage - 1) * itemsPerPage) + index + 1}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                              <div className="flex-shrink-0 h-12 w-12">
                                {card.image ? (
                                  <img
                                    src={card.image}
                                    alt={card.name || 'User'}
                                    className="h-12 w-12 rounded-full object-cover border-2 border-gray-200"
                                  />
                                ) : (
                                  <div className="h-12 w-12 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center">
                                    <FaUser className="w-6 h-6 text-white" />
                                  </div>
                                )}
                              </div>
                              <div className="ml-4">
                                <div className="text-sm font-medium text-gray-900">{card.name || 'Unknown'}</div>
                                <div className="text-sm text-gray-500">{card.designation || 'N/A'}</div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-mono text-gray-900 bg-green-100 px-3 py-1 rounded-lg inline-block">
                              {card.iinsafId || 'Not Assigned'}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{card.email || 'N/A'}</div>
                            <div className="text-sm text-gray-500 flex items-center gap-1">
                              <FaPhone className="w-3 h-3" />
                              {card.mobileNo || 'N/A'}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{card.city || 'N/A'}</div>
                            <div className="text-sm text-gray-500">{card.state || 'N/A'}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">
                              {card.updatedAt ? new Date(card.updatedAt).toLocaleDateString('en-GB') : 'N/A'}
                            </div>
                            <div className="text-sm text-gray-500">
                              {card.updatedAt ? new Date(card.updatedAt).toLocaleTimeString('en-US', {
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true
                              }) : 'N/A'}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {card.createdAt ? (() => {
                              const d = new Date(card.createdAt);
                              const day = String(d.getDate()).padStart(2, '0');
                              const month = String(d.getMonth() + 1).padStart(2, '0');
                              const year = String(d.getFullYear()).slice(-2);
                              return `${day}/${month}/${year}`;
                            })() : 'N/A'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className="inline-flex px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                              {card.status || 'Approved'}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            {card.channelLinks && card.channelLinks.length > 0 ? (
                              <div className="flex flex-wrap gap-1">
                                {card.channelLinks.slice(0, 2).map((link, linkIndex) => (
                                  <a
                                    key={linkIndex}
                                    href={link.link || link.url || link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
                                  >
                                    <FaLink className="w-3 h-3 mr-1" />
                                    {link.platform || `Link ${linkIndex + 1}`}
                                  </a>
                                ))}
                                {card.channelLinks.length > 2 && (
                                  <span className="text-xs text-gray-500">+{card.channelLinks.length - 2} more</span>
                                )}
                              </div>
                            ) : (
                              <span className="text-sm text-gray-400">No channels</span>
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <div className="flex flex-col gap-2">
                              <button
                                className="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition-colors"
                                onClick={() =>
                                  navigate("/admin/downloadreporteridcards", {
                                    state: { reporter: card },
                                  })
                                }
                              >
                                <FaDownload className="w-3 h-3 mr-1" />
                                Download
                              </button>
                              <button
                                className="inline-flex items-center px-3 py-1.5 bg-yellow-600 text-white text-xs font-medium rounded-lg hover:bg-yellow-700 transition-colors"
                                onClick={() => {
                                  setSelectedCard(card);
                                  setProfileImageFile(null);
                                  setChannelLogoFile(null);
                                  setShowEditModal(true);
                                }}
                              >
                                <FaEdit className="w-3 h-3 mr-1" />
                                Edit
                              </button>
                              <button
                                className="inline-flex items-center px-3 py-1.5 bg-red-600 text-white text-xs font-medium rounded-lg hover:bg-red-700 transition-colors"
                                onClick={() => handleDeleteCard(card._id)}
                              >
                                <FaTrash className="w-3 h-3 mr-1" />
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                    <div className="flex items-center justify-between">
                      <div className="text-sm text-gray-700">
                        Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalCount)} of {totalCount} results
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                          disabled={currentPage === 1}
                          className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                        >
                          <FaArrowLeft className="w-3 h-3" />
                          Previous
                        </button>
                        <div className="flex space-x-1">
                          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                            const pageNum = i + 1;
                            return (
                              <button
                                key={pageNum}
                                onClick={() => handlePageChange(pageNum)}
                                className={`px-3 py-2 text-sm font-medium rounded-lg ${currentPage === pageNum
                                  ? 'bg-green-600 text-white'
                                  : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                                  }`}
                              >
                                {pageNum}
                              </button>
                            );
                          })}
                        </div>
                        <button
                          onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
                          disabled={currentPage === totalPages}
                          className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                        >
                          Next
                          <FaArrowRight className="w-3 h-3" />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-16">
                <div className="w-24 h-24 bg-gradient-to-br from-gray-200 to-gray-300 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FaIdCard className="w-12 h-12 text-gray-400" />
                </div>
                <h3 className="text-xl font-semibold text-gray-600 mb-2">No Approved ID Cards Found</h3>
                <p className="text-gray-500 mb-4">
                  {search
                    ? "No cards match your current search."
                    : "No approved ID cards available at the moment."
                  }
                </p>
                {search && (
                  <button
                    onClick={() => {
                      setSearch("");
                    }}
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                  >
                    Clear Filters
                  </button>
                )}
              </div>
            )}
          </div>

          {/* Loading Spinner */}
          {showApproveSpinner && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="flex flex-col items-center p-8 bg-white rounded-2xl shadow-2xl border border-green-200 animate-fadeIn">
                <div className="relative mb-4 w-16 h-16 grid place-items-center">
                  <span className="absolute inset-0 rounded-full border-4 border-transparent border-r-green-600 animate-spin" style={{ borderWidth: "4px" }} />
                  <span className="absolute inset-0 m-1 rounded-full border-4 border-transparent border-r-green-500 animate-spin-slow" style={{ borderWidth: "4px", animationDuration: "2s" }} />
                  <span className="absolute inset-0 m-2 rounded-full border-4 border-transparent border-r-green-400 animate-spin-slower" style={{ borderWidth: "4px", animationDuration: "3s" }} />
                </div>
                <span className="text-lg font-semibold text-green-700 tracking-wide">Processing Update...</span>
                <span className="text-sm text-gray-500 mt-2">Please wait while we save the changes.</span>
              </div>
            </div>
          )}

          {/* Edit Modal */}
          {showEditModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4 overflow-y-auto">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                {/* Modal Header */}
                <div className="sticky top-0 bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 px-6 py-6 flex justify-between items-center">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center">
                      <FaEdit className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-white">Edit ID Card</h2>
                      <p className="text-green-100">Update ID card information</p>
                    </div>
                  </div>
                  <button
                    className="text-white hover:text-green-200 transition-colors p-2 rounded-lg hover:bg-white hover:bg-opacity-10"
                    onClick={() => {
                      setShowEditModal(false);
                      setProfileImageFile(null);
                      setChannelLogoFile(null);
                    }}
                    title="Close"
                  >
                    <FaTimes className="w-6 h-6" />
                  </button>
                </div>

                {/* Modal Content */}
                <div className="p-6 space-y-8">
                  {/* Form for editing ID card */}
                  <form
                    className="space-y-6"
                    onSubmit={(e) => e.preventDefault()}
                  >
                    {/* Image and Channel Logo */}
                    <div className="mb-3">
                      <div className="flex flex-row items-center space-x-6 justify-start">
                        {/* Reporter Image */}
                        <div className="relative flex flex-col items-center">
                          <label className="block text-xs text-gray-500 mb-1">Reporter Image</label>
                          {selectedCard?.image ? (
                            <img
                              src={selectedCard.image}
                              alt={selectedCard.name || "Reporter"}
                              className="h-14 w-14 rounded-full object-cover border-2 border-gray-200 mb-1 cursor-pointer hover:border-green-400 transition-colors"
                              onClick={() => document.getElementById('imageUpload').click()}
                              title="Click to change image"
                            />
                          ) : (
                            <div
                              className="h-14 w-14 rounded-full bg-gray-200 flex items-center justify-center mb-1 cursor-pointer hover:bg-gray-300 transition-colors"
                              onClick={() => document.getElementById('imageUpload').click()}
                              title="Click to upload image"
                            >
                              <FaIdCard className="text-gray-400 text-xl" />
                            </div>
                          )}
                          <input
                            id="imageUpload"
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setProfileImageFile(file);
                                const reader = new FileReader();
                                reader.onload = (event) => {
                                  setSelectedCard({
                                    ...selectedCard,
                                    image: event.target.result,
                                  });
                                };
                                reader.readAsDataURL(file);
                              }
                            }}
                          />

                        </div>
                        {/* Channel Logo */}
                        <div className="relative flex flex-col items-center">
                          <label className="block text-xs text-gray-500 mb-1">Channel Logo</label>
                          {selectedCard?.channelLogo ? (
                            <img
                              src={selectedCard.channelLogo}
                              alt="Channel Logo"
                              className="h-14 w-14 rounded-full object-cover border-2 border-gray-200 mb-1 cursor-pointer hover:border-green-400 transition-colors"
                              onClick={() => document.getElementById('channelLogoUpload').click()}
                              title="Click to change logo"
                            />
                          ) : (
                            <div
                              className="h-14 w-14 rounded-full bg-gray-200 flex items-center justify-center mb-1 cursor-pointer hover:bg-gray-300 transition-colors"
                              onClick={() => document.getElementById('channelLogoUpload').click()}
                              title="Click to upload logo"
                            >
                              <FaIdCard className="text-gray-400 text-xl" />
                            </div>
                          )}
                          <input
                            id="channelLogoUpload"
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setChannelLogoFile(file);
                                const reader = new FileReader();
                                reader.onload = (event) => {
                                  setSelectedCard({
                                    ...selectedCard,
                                    channelLogo: event.target.result,
                                  });
                                };
                                reader.readAsDataURL(file);
                              }
                            }}
                          />

                        </div>
                      </div>
                      {/* Input fields below images */}
                      <div className="flex flex-row space-x-4 mt-2">
                        <div className="flex-1">
                          <label className="block text-xs text-gray-500 mb-1">
                            Full Name
                          </label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded mb-2 text-gray-800 font-medium"
                            value={selectedCard?.name || ""}
                            onChange={(e) =>
                              setSelectedCard({
                                ...selectedCard,
                                name: e.target.value,
                              })
                            }
                            placeholder="Full Name"
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-xs text-gray-500 mb-1">
                            Designation
                          </label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded text-gray-600"
                            value={selectedCard?.designation || ""}
                            onChange={(e) =>
                              setSelectedCard({
                                ...selectedCard,
                                designation: e.target.value,
                              })
                            }
                            placeholder="Designation"
                          />
                        </div>
                      </div>
                    </div>
                    {/* Readonly fields */}
                    <label className="block text-xs text-gray-500 mb-1">
                      ID Number
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded text-gray-500 mb-2"
                      value={selectedCard?._id || ""}
                      readOnly
                      placeholder="ID Number"
                    />
                    <label className="block text-xs text-gray-500 mb-1">Status</label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded text-gray-500 mb-2"
                      value={selectedCard?.status || ""}
                      readOnly
                      placeholder="Status"
                    />
                    {/* Editable fields */}
                    <label className="block text-xs text-gray-500 mb-1">Email</label>
                    <input
                      type="email"
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.email || ""}
                      onChange={(e) =>
                        setSelectedCard({ ...selectedCard, email: e.target.value })
                      }
                      placeholder="Email"
                    />
                    <label className="block text-xs text-gray-500 mb-1">
                      Mobile Number
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.mobileNo || ""}
                      onChange={(e) =>
                        setSelectedCard({ ...selectedCard, mobileNo: e.target.value })
                      }
                      placeholder="Mobile Number"
                    />
                    <label className="block text-xs text-gray-500 mb-1">
                      Aadhar Number
                    </label>
                    <input
                      type="number"
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.aadharNo || ""}
                      onChange={(e) =>
                        setSelectedCard({ ...selectedCard, aadharNo: e.target.value })
                      }
                      placeholder="Aadhar Number"
                    />
                    <label className="block text-xs text-gray-500 mb-1">
                      Blood Group
                    </label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.bloodGroup || ""}
                      onChange={(e) =>
                        setSelectedCard({
                          ...selectedCard,
                          bloodGroup: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Blood Group</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                    </select>
                    <label className="block text-xs text-gray-500 mb-1">
                      Date of Birth
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        className="w-full px-3 py-2 border border-gray-300 rounded mb-2 pr-10"
                        value={selectedCard?.dateOfBirth || ""}
                        onChange={(e) =>
                          setSelectedCard({
                            ...selectedCard,
                            dateOfBirth: e.target.value,
                          })
                        }
                        placeholder="Date of Birth"
                      />
                      <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">

                      </span>
                    </div>
                    <label className="block text-xs text-gray-500 mb-1">
                      Channel Name
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.channelName || ""}
                      onChange={(e) =>
                        setSelectedCard({
                          ...selectedCard,
                          channelName: e.target.value,
                        })
                      }
                      placeholder="Channel Name"
                    />
                    <label className="block text-xs text-gray-500 mb-1">
                      Channel Type
                    </label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.channelType || ""}
                      onChange={e =>
                        setSelectedCard({
                          ...selectedCard,
                          channelType: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Channel Type</option>
                      {channelTypes.map((type, idx) => {
                        // If type is an object, use .name or .label, else use as string
                        const value = typeof type === 'object' && type !== null ? (type.name || type.label || type._id || JSON.stringify(type)) : type;
                        return (
                          <option key={idx} value={value}>{value}</option>
                        );
                      })}
                    </select>
                    <label className="block text-xs text-gray-500 mb-1">
                      Platform
                    </label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.plateform || ""}
                      onChange={e =>
                        setSelectedCard({
                          ...selectedCard,
                          plateform: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Platform</option>
                      {platforms.map((plat, idx) => {
                        // If platform is an object, use .name or .label, else use as string
                        const value = typeof plat === 'object' && plat !== null ? (plat.name || plat.label || plat._id || JSON.stringify(plat)) : plat;
                        return (
                          <option key={idx} value={value}>{value}</option>
                        );
                      })}
                    </select>

                    <label className="block text-xs text-gray-500 mb-1">
                      Residential Address
                    </label>
                    {/* Address fields */}
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.ResidentialAddress || ""}
                      onChange={(e) =>
                        setSelectedCard({
                          ...selectedCard,
                          ResidentialAddress: e.target.value,
                        })
                      }
                      placeholder="Residential Address"
                    />
                    <div className="flex space-x-2 mb-2">
                      <div className="w-1/2">
                        <label className="block text-xs text-gray-500 mb-1">State</label>
                        <select
                          className="w-full px-3 py-2 border border-gray-300 rounded"
                          value={selectedCard?.state || ""}
                          onChange={e => {
                            setSelectedCard({ ...selectedCard, state: e.target.value, city: "" });
                          }}
                        >
                          <option value="">Select State</option>
                          {Object.keys(stateCityData).map((state, idx) => (
                            <option key={idx} value={state}>{state}</option>
                          ))}
                        </select>
                      </div>
                      <div className="w-1/2">
                        <label className="block text-xs text-gray-500 mb-1">City</label>
                        <select
                          className="w-full px-3 py-2 border border-gray-300 rounded"
                          value={selectedCard?.city || ""}
                          onChange={e => setSelectedCard({ ...selectedCard, city: e.target.value })}
                          disabled={!selectedCard?.state}
                        >
                          <option value="">Select City</option>
                          {(stateCityData[selectedCard?.state] || []).map((city, idx) => (
                            <option key={idx} value={city}>{city}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <label className="block text-xs text-gray-500 mb-1">
                      Pincode
                    </label>
                    <input
                      type="number"
                      className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
                      value={selectedCard?.pincode || ""}
                      onChange={(e) =>
                        setSelectedCard({ ...selectedCard, pincode: e.target.value })
                      }
                      placeholder="Pincode"
                    />
                    {/* Dates and status (readonly) */}
                    <label className="block text-xs text-gray-500 mb-1">
                      Created At
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded text-gray-500 mb-2"
                      value={
                        selectedCard?.createdAt
                          ? new Date(selectedCard.createdAt).toLocaleDateString()
                          : ""
                      }
                      readOnly
                      placeholder="Created At"
                    />
                    <label className="block text-xs text-gray-500 mb-1">
                      Issued Date
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded text-gray-500 mb-2"
                      value={selectedCard?.issuedDate || ""}
                      readOnly
                      placeholder="Issued Date"
                    />
                    <label className="block text-xs text-gray-500 mb-1">
                      Valid Upto
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded text-gray-500 mb-2"
                      value={selectedCard?.validUpto || ""}
                      readOnly
                      placeholder="Valid Upto"
                    />
                    <label className="block text-xs text-gray-500 mb-1">
                      Last Updated
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded text-gray-500 mb-2"
                      value={
                        selectedCard?.updatedAt
                          ? new Date(selectedCard.updatedAt).toLocaleString()
                          : ""
                      }
                      readOnly
                      placeholder="Last Updated"
                    />
                    {/* Channel Links Section */}
                    {selectedCard?.channelLinks &&
                      selectedCard.channelLinks.length > 0 && (
                        <div className="space-y-2">
                          <label className="block text-xs text-gray-500 mb-1">
                            Channel Links
                          </label>
                          {selectedCard.channelLinks.map((link, idx) => (
                            <div key={idx} className="flex space-x-2">
                              <div className="w-1/3">
                                <label className="block text-xs text-gray-500 mb-1">
                                  Platform
                                </label>
                                <input
                                  type="text"
                                  className="w-full px-3 py-2 border border-gray-300 rounded"
                                  value={link.platform || ""}
                                  onChange={(e) => {
                                    const newLinks = [...selectedCard.channelLinks];
                                    newLinks[idx] = {
                                      ...newLinks[idx],
                                      platform: e.target.value,
                                    };
                                    setSelectedCard({
                                      ...selectedCard,
                                      channelLinks: newLinks,
                                    });
                                  }}
                                  placeholder="Platform"
                                />
                              </div>
                              <div className="w-2/3">
                                <label className="block text-xs text-gray-500 mb-1">
                                  Channel Link
                                </label>
                                <input
                                  type="url"
                                  className="w-full px-3 py-2 border border-gray-300 rounded"
                                  value={link.link || link.url || ""}
                                  onChange={(e) => {
                                    const newLinks = [...selectedCard.channelLinks];
                                    newLinks[idx] = {
                                      ...newLinks[idx],
                                      link: e.target.value,
                                    };
                                    setSelectedCard({
                                      ...selectedCard,
                                      channelLinks: newLinks,
                                    });
                                  }}
                                  placeholder="Channel Link"
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                  </form>

                  {/* Action Buttons */}
                  <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
                    <button
                      className="px-6 py-3 bg-gray-500 text-white rounded-xl hover:bg-gray-600 transition-colors font-medium"
                      onClick={() => {
                        setShowEditModal(false);
                        setProfileImageFile(null);
                        setChannelLogoFile(null);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl hover:from-green-700 hover:to-emerald-700 transition-all duration-200 font-medium shadow-lg flex items-center gap-2"
                    >
                      <FaSave className="w-4 h-4" />
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VerifiedIdCard;
